import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { NotificationMessage, NotificationRequest } from '../notification.interfaces';
import { config } from '../../app.config';

@Injectable()
export class NotificationsService {
  constructor(private http: CHttp) {}

  sendNotification(message: NotificationMessage, topics: string[]) {
    const request: NotificationRequest = { message, topics };
    return this.http.post(`${config.api_url}notifications/send`, request);
  }

  advertiseOffer(offerId: string, message: NotificationMessage, topics: string[]) {
    const request: NotificationRequest = { message, topics };
    return this.http.post(`${config.api_url}notifications/${offerId}/advertise`, request);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/notifications/services/notifications.service.ts